export default __webpack_public_path__ + "static/media/CommuniCapture.a3b0dab74bd4bbaf0523e6b4f0644c30.webp";